import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	ordersBtb: {
		error: null,
		loading: false,
		data: [],
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	orderBtb: { error: null, loading: false, data: null },
	createdOrderBtb: { error: null, loading: false, data: null },
	editedOrderBtb: { error: null, loading: false, data: null },
	statuses: { error: null, loading: false, data: null },
	downloadCsv: { error: null, loading: false },
	dispatchList: [],
	dispatchedOrdersBtb: { error: null, loading: false, data: null },
};

const { actions, reducer } = createSlice({
	name: 'ordersBtb',
	initialState,
	reducers: {
		getOrdersBtb: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.ordersBtb = {
				...state.ordersBtb,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getOrdersBtbFailure: (state, { payload }) => {
			state.ordersBtb = {
				...state.ordersBtb,
				error: payload,
				loading: false,
			};
		},
		getOrdersBtbSuccess: (state, { payload }) => {
			state.ordersBtb = {
				...state.ordersBtb,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getOrderBtbById: (state, { payload }) => {
			state.orderBtb = {
				...state.orderBtb,
				error: null,
				loading: true,
			};
		},
		getOrderBtbByIdFailure: (state, { payload }) => {
			state.orderBtb = {
				...state.orderBtb,
				error: payload,
				loading: false,
			};
		},
		getOrderBtbByIdSuccess: (state, { payload }) => {
			state.orderBtb = {
				...state.orderBtb,
				data: payload,
				error: null,
				loading: false,
			};
		},
		createOrderBtb: (state, { payload }) => {
			state.createdOrderBtb = {
				...state.createdOrderBtb,
				error: null,
				loading: true,
			};
		},
		createOrderBtbFailure: (state, { payload }) => {
			state.createdOrderBtb = {
				...state.createdOrderBtb,
				error: payload,
				loading: false,
			};
		},
		createOrderBtbSuccess: (state, { payload }) => {
			state.createdOrderBtb = {
				...state.createdOrderBtb,
				data: payload,
				error: null,
				loading: false,
			};
		},
		finalizeOrderBtb: (state, { payload }) => {
			state.editedOrderBtb = {
				...state.editedOrderBtb,
				error: null,
				loading: true,
			};
		},
		finalizeOrderBtbFailure: (state, { payload }) => {
			state.editedOrderBtb = {
				...state.editedOrderBtb,
				error: payload,
				loading: false,
			};
		},
		finalizeOrderBtbSuccess: (state, { payload }) => {
			state.editedOrderBtb = {
				...state.editedOrderBtb,
				data: payload,
				error: null,
				loading: false,
			};
		},
		unfullfillOrderBtb: (state, { payload }) => {
			state.editedOrderBtb = {
				...state.editedOrderBtb,
				error: null,
				loading: true,
			};
		},
		unfullfillOrderBtbFailure: (state, { payload }) => {
			state.editedOrderBtb = {
				...state.editedOrderBtb,
				error: payload,
				loading: false,
			};
		},
		unfullfillOrderBtbSuccess: (state, { payload }) => {
			state.editedOrderBtb = {
				...state.editedOrderBtb,
				data: payload,
				error: null,
				loading: false,
			};
		},
		downloadCsv: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: null,
				loading: true,
			};
		},
		downloadCsvFailure: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: payload,
				loading: false,
			};
		},
		downloadCsvSuccess: (state, { payload }) => {
			state.downloadCsv = {
				...state.downloadCsv,
				error: null,
				loading: false,
			};
		},
		getOrderStatuses: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: null,
				loading: true,
			};
		},
		getOrderStatusesFailure: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				error: payload,
				loading: false,
			};
		},
		getOrderStatusesSuccess: (state, { payload }) => {
			state.statuses = {
				...state.statuses,
				data: payload,
				error: null,
				loading: false,
			};
		},
		addDispatchItem: (state, { payload }) => {
			state.dispatchList = [...state.dispatchList, { ...payload, id: state.dispatchList.length }];
		},
		addDispatchItems: (state, { payload }) => {
			payload.forEach((item) => {
				state.dispatchList.push({ ...item, id: state.dispatchList.length });
			});
		},
		resetDispatchList: (state, { payload }) => {
			state.dispatchList = [];
		},
		removeDispatchItem: (state, { payload }) => {
			state.dispatchList = state.dispatchList.filter((item) => item.id !== payload.id);
		},
		removeDispatchItemsByCodes: (state, { payload }) => {
			state.dispatchList = state.dispatchList.filter(
				(item) => !payload.includes(item.trackingCode),
			);
		},
		dispatchOrdersBtb: (state, { payload }) => {
			state.dispatchedOrdersBtb = {
				...state.dispatchedOrdersBtb,
				error: null,
				loading: true,
			};
		},
		dispatchOrdersBtbFailure: (state, { payload }) => {
			state.dispatchedOrdersBtb = {
				...state.dispatchedOrdersBtb,
				error: payload,
				loading: false,
			};
		},
		dispatchOrdersBtbSuccess: (state, { payload }) => {
			state.dispatchedOrdersBtb = {
				...state.dispatchedOrdersBtb,
				data: payload,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	getOrdersBtb,
	getOrdersBtbFailure,
	getOrdersBtbSuccess,
	getOrderBtbById,
	getOrderBtbByIdFailure,
	getOrderBtbByIdSuccess,
	createOrderBtb,
	createOrderBtbFailure,
	createOrderBtbSuccess,
	finalizeOrderBtb,
	finalizeOrderBtbFailure,
	finalizeOrderBtbSuccess,
	unfullfillOrderBtb,
	unfullfillOrderBtbFailure,
	unfullfillOrderBtbSuccess,
	downloadCsv,
	downloadCsvFailure,
	downloadCsvSuccess,
	getOrderStatuses,
	getOrderStatusesFailure,
	getOrderStatusesSuccess,
	addDispatchItem,
	addDispatchItems,
	resetDispatchList,
	removeDispatchItem,
	removeDispatchItemsByCodes,
	dispatchOrdersBtb,
	dispatchOrdersBtbFailure,
	dispatchOrdersBtbSuccess,
} = actions;

export { default as ordersBtbSaga } from './sagas';

export default reducer;
